import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Masthead = _resolveComponent("Masthead")!
  const _component_PaginatedResourceTable = _resolveComponent("PaginatedResourceTable")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Masthead, {
      "component-testid": "secrets-list",
      schema: $data.schema,
      typeDisplay: $data.mastheadLabel,
      resource: $data.SECRET,
      favoriteResource: $data.PROJECT_SECRETS,
      "create-location": $options.createLocation,
      isCreatable: true
    }, null, 8, ["schema", "typeDisplay", "resource", "favoriteResource", "create-location"]),
    _cache[0] || (_cache[0] = _createTextVNode()),
    _createVNode(_component_PaginatedResourceTable, {
      groupSort: $options.groupSort,
      groupable: true,
      groupOptions: $data.groupOptions,
      schema: $data.schema,
      headers: $data.projectedScopedHeaders,
      namespaced: false,
      "pagination-headers": $data.projectedScopedHeadersSsp,
      "local-filter": $options.filterRowsLocal,
      "api-filter": $options.filterRowsApi,
      "use-query-params-for-simple-filtering": $props.useQueryParamsForSimpleFiltering,
      overrideInStore: $data.STORE.MANAGEMENT
    }, null, 8, ["groupSort", "groupOptions", "schema", "headers", "pagination-headers", "local-filter", "api-filter", "use-query-params-for-simple-filtering", "overrideInStore"])
  ]))
}